import type { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor that adds base server URL to all HTTP requests
 * @param req - HTTP request
 * @param next - Next handler in the interceptor chain
 * @returns Observable with modified request
 */
export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.endsWith('.html')) {
    return next(req);
  }

  const modifiedReq = req.clone({
    url: `${req.url.startsWith('http') ? '' : __API_URL}${req.url}`,
  });

  return next(modifiedReq);
};
